module.exports = __webpack_public_path__ + "img/CATEGORY ICON-01.94e51fac.png";